// extracted by mini-css-extract-plugin
module.exports = {"OASIS-E":"OASIS4_OASIS-E__wAMWX"};